var _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftLeaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 328,
    viewBox: "0 0 274 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "left-leaves_svg__mask0_613_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 274,
    height: 328
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 328h274V0H0v328z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#left-leaves_svg__mask0_613_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.08 332.809c-30.645-39.844-70.519-72.216-119.986-76.151-31.562-2.587-63.13 5.858-90.712 24.268 19.444-29.425 31.04-64.895 33.32-101.922C49.22 123.66 30.064 73.611 2.54 34.324c-1.34-1.811-2.619-3.684-3.95-5.486l-4.577-6.193L-21.3 38.224a171.197 171.197 0 00-5.921 6.32c-28.362 31.767-47.97 75.926-51.054 124.568-3.267 51.532 23.854 116.448 50.317 152.698l.103.14c26.89 35.938 77.753 76.56 121.726 80.065 42.422 3.392 83.342-13.996 114.395-43.6l19.258-19.592-4.444-6.014zM-64.439 167.854c.074.099 0 0 0 0z",
    fill: "#fff"
  }))));
}
export default SvgLeftLeaves;